// /Users/adrian.leineweber/Development/gemini-test/client/src/components/Login.js
import React, { useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Paper, Button, Container } from '@mui/material';

const Login = () => {
  const navigate = useNavigate();
  const buttonDivRef = useRef(null);
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const logoPath = '/images/familiothek-logo.png'; // Pfad zum Logo

  console.log('Login.js: Komponente gerendert');

  const handleCredentialResponse = useCallback(
    (response) => {
      console.log('Login.js: handleCredentialResponse - Start', response);
      const googleToken = response.credential; // Das ist der Google ID Token
      console.log('Login.js: handleCredentialResponse - Google token', googleToken);
      console.log('Login.js: handleCredentialResponse - backendUrl', backendUrl);
      fetch(`${backendUrl}/api/auth/google`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ token: googleToken }), // Sende den Google Token an das Backend
      })
        .then((response) => {
          console.log('Login.js: handleCredentialResponse - fetch response', response);
          if (!response.ok) {
            // Versuche, Fehlerdetails aus der Antwort zu lesen
            return response.json().then(errData => {
                throw new Error(`Login fehlgeschlagen: ${response.status} - ${errData.message || 'Unbekannter Fehler'}`);
            }).catch(() => {
                // Fallback, wenn die Antwort kein JSON ist
                throw new Error(`Login fehlgeschlagen: ${response.status}`);
            });
          }
          return response.json();
        })
        .then((data) => {
          console.log('Login.js: handleCredentialResponse - fetch data', data);
          if (data.success && data.token) { // Stelle sicher, dass ein Token vorhanden ist
            console.log('Login.js: handleCredentialResponse - Login erfolgreich');
            // *** DIE ENTSCHEIDENDE KORREKTUR ***
            localStorage.setItem('token', data.token); // Speichere den Backend-JWT unter dem Schlüssel 'token'
            console.log('Login.js: navigate to /booklist');
            navigate('/booklist');
          } else {
            console.error('Login.js: handleCredentialResponse - Login fehlgeschlagen oder kein Token erhalten:', data.message);
            // Optional: Zeige dem Benutzer eine Fehlermeldung an
          }
        })
        .catch((error) => {
          console.error('Login.js: handleCredentialResponse - fetch error', error);
          // Optional: Zeige dem Benutzer eine Fehlermeldung an
        });
    },
    [navigate, backendUrl]
  );

  useEffect(() => {
    console.log('Login.js: useEffect - Start');
    // Prüfe, ob das Skript bereits geladen wurde, um Duplikate zu vermeiden
    if (document.getElementById('google-gsi-client')) {
        console.log('Login.js: useEffect - Google API Skript bereits vorhanden');
        // Initialisierung und Button-Rendering erneut versuchen, falls nötig
        if (window.google && window.google.accounts && window.google.accounts.id && buttonDivRef.current && !buttonDivRef.current.hasChildNodes()) {
             window.google.accounts.id.initialize({
               client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
               callback: handleCredentialResponse,
             });
             window.google.accounts.id.renderButton(buttonDivRef.current, {
               theme: 'outline',
               size: 'large',
             });
             console.log('Login.js: useEffect - Button erneut gerendert');
        }
        return; // Skript nicht erneut hinzufügen
    }

    const script = document.createElement('script');
    script.id = 'google-gsi-client'; // ID hinzufügen, um Duplikate zu erkennen
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true; // defer hinzugefügt
    script.onload = () => {
      console.log('Login.js: useEffect - Google API Skript geladen');
      if (window.google && window.google.accounts && window.google.accounts.id) {
        console.log('Login.js: useEffect - Google API vorhanden');
        window.google.accounts.id.initialize({
          client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
          callback: handleCredentialResponse,
        });
        console.log('Login.js: useEffect - Google API initialisiert');
        if (buttonDivRef.current) {
            window.google.accounts.id.renderButton(buttonDivRef.current, {
              theme: 'outline',
              size: 'large',
            });
            console.log('Login.js: useEffect - Button gerendert');
        } else {
            console.error('Login.js: useEffect - buttonDivRef nicht vorhanden beim Rendern');
        }
      } else {
        console.error('Login.js: useEffect - Google API Objekt (window.google.accounts.id) nicht vorhanden nach Laden');
      }
    };
    script.onerror = () => {
      console.error('Login.js: useEffect - Fehler beim Laden des Google API Skripts');
    };
    document.body.appendChild(script);
    console.log('Login.js: useEffect - Skript hinzugefügt');

    // Cleanup-Funktion (optional, siehe Kommentar)
    return () => {
        const existingScript = document.getElementById('google-gsi-client');
        if (existingScript) {
            // document.body.removeChild(existingScript);
            // console.log('Login.js: useEffect - Google API Skript entfernt');
        }
    };
  }, [handleCredentialResponse]);

  return (
    <Container maxWidth="sm" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <Paper elevation={3} sx={{ p: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
        <Box sx={{ width: '200px', height: 'auto', mb: 2 }}>
          <img src={logoPath} alt="Familiothek Logo" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
        </Box>
        <div ref={buttonDivRef}></div>
        <Typography variant="body2" color="text.secondary">
          Melde dich mit deinem Google-Konto an.
        </Typography>
      </Paper>
    </Container>
  );
};

export default Login;
